<section class="contact">
  <svg preserveAspectRatio="none" viewBox="0 0 1728 147" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 0H72C144 0 288 0 432 14C576 28 720 56 864 63C1008 70 1152 56 1296 45.5C1440 35 1584 28 1656 24.5L1728 21V147H1656C1584 147 1440 147 1296 147C1152 147 1008 147 864 147C720 147 576 147 432 147C288 147 144 147 72 147H0V0Z"
      fill="#FFF"
    />
  </svg>
  <div class="float-container">
    <div class="contact__container">
      <article class="contact__container__content">
        <header class="header">
          <img class="header__avatar" [src]="'contact.team' | translate | avatarUrl" [alt]="'contact.team.seo.title' | translate" />
          <div class="header__content">
            <h2 class="header__content__title">{{ 'contact.card.content.title' | translate }}</h2>
            <p class="header__content__name">
              {{ 'contact.team.seo.title' | translate }}
            </p>
          </div>
        </header>
        <p class="contact__container__content__text">{{ 'contact.card.content.description' | translate }}</p>
        <placeme-chips-container class="contact__container__content__list">
          <placeme-chips *ngFor="let item of 'contact.items' | translate" class="contact__container__content__list__item">
            {{ item.label }}
          </placeme-chips>
        </placeme-chips-container>
        <button (click)="booking()" class="contact__container__content__button" placeme-stroked-button>
          {{ 'contact.card.cta.label' | translate }}
        </button>
      </article>
      <img
        class="contact__container__illustration"
        [src]="'contact.card.content.image.url' | translate"
        [alt]="'contact.card.content.title' | translate"
      />
    </div>
  </div>
</section>
